import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Check, Trash2, X } from "lucide-react";

const KIND_LABEL = { project: "Projet artistique", management: "Contact pro", studio: "Studio", booking: "Booking" };

export default function AdminRequests() {
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("");
  const [detail, setDetail] = useState(null);

  const load = () => api.get(`/admin/requests${kind ? `?kind=${kind}` : ""}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind]);

  const handle = async (r) => {
    try { await api.post(`/admin/requests/${r._collection}/${r.id}/handle`); toast.success("Marqué comme traité"); load(); setDetail(null); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const remove = async (r) => {
    if (!window.confirm("Supprimer cette demande (RGPD) ?")) return;
    try { await api.delete(`/admin/requests/${r._collection}/${r.id}`); toast.success("Supprimé"); load(); setDetail(null); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-requests">
      <h1 className="font-display font-black text-3xl mb-8">Demandes</h1>
      <div className="flex flex-wrap gap-2 mb-6">
        {[["", "Toutes"], ["project", "Projet artistique"], ["management", "Contact pro"], ["studio", "Studio"], ["booking", "Booking"]].map(([k, l]) => (
          <button key={k} onClick={() => setKind(k)} className={`px-4 py-1.5 rounded-full text-xs font-semibold border ${kind === k ? "bg-gold text-black border-transparent" : "border-white/15 text-slate-300"}`}>{l}</button>
        ))}
      </div>
      <div className="card-dark overflow-x-auto">
        {items.length === 0 ? <div className="p-10 text-center text-slate-500 text-sm">Aucune demande.</div> : (
          <table className="w-full text-sm">
            <thead className="text-left text-slate-500 border-b border-white/10"><tr><th className="p-4">Type</th><th className="p-4">Nom</th><th className="p-4">Email</th><th className="p-4">Date</th><th className="p-4">Statut</th></tr></thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} onClick={() => setDetail(r)} className="border-b border-white/5 cursor-pointer hover:bg-white/5">
                  <td className="p-4"><span className="eyebrow">{KIND_LABEL[r.kind] || r.kind}</span></td>
                  <td className="p-4">{r.nom ? `${r.prenom || ""} ${r.nom}` : r.artiste || "—"}</td>
                  <td className="p-4 text-slate-400">{r.email}</td>
                  <td className="p-4 text-slate-500">{(r.created_at || "").slice(0, 10)}</td>
                  <td className="p-4">{r.status === "new" ? <span className="text-amber-400 text-xs">Nouveau</span> : <span className="text-slate-500 text-xs">Traité</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {detail && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setDetail(null)} />
          <div className="relative card-dark w-full max-w-lg p-8 max-h-[85vh] overflow-y-auto">
            <button onClick={() => setDetail(null)} className="absolute top-5 right-5 text-slate-400"><X size={20} /></button>
            <div className="eyebrow mb-4">{KIND_LABEL[detail.kind] || detail.kind}</div>
            {Object.entries(detail).filter(([k]) => !["_collection", "id", "kind", "status", "consent", "website"].includes(k)).map(([k, v]) => (
              v ? <div key={k} className="py-1.5 border-b border-white/5"><span className="text-slate-500 text-xs uppercase">{k}</span><div className="text-sm text-white mt-0.5">{String(v)}</div></div> : null
            ))}
            <div className="flex gap-2 mt-6">
              {detail.status === "new" && <button onClick={() => handle(detail)} className="btn-gold !py-2 text-xs"><Check size={14} /> Marquer traité</button>}
              <button onClick={() => remove(detail)} className="btn-ghost !py-2 text-xs text-red-400"><Trash2 size={14} /> Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
